import React from "react";
import PageLayout from "../components/PageLayout.jsx";
import FormatText from "../components/FormatText.jsx";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Carousel from "../components/Carousel.jsx";
import { proofCarousel } from "../main.jsx";

export default function Home() {
  const { t } = useTranslation();

  return (
    <PageLayout title="Home" isFullWidth={true} className={"bg-gray-900"}>
      <section aria-labelledby="section-heading">
        <div className="dark relative bg-gray-800 px-6 py-4 transition-[padding] sm:px-12 sm:py-10 md:py-15 lg:px-16 lg:py-20">
          {/*<CoverImage imageUrl="https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5?q=80"/>*/}
          <div aria-hidden="true" className="bg-proof-blue absolute inset-0"></div>
          <div aria-hidden="true" className="bg-opacity-80 absolute inset-0 bg-gray-900"></div>
          <div className="relative mx-auto flex max-w-full flex-col items-center text-center">
            {/*<img className="object-cover h-24 mb-10" src="/images/proof-logo.png" alt={t('proof.title')}/>*/}
            <h2 id="section-heading" className="text-2xl font-bold tracking-tight text-white">
              <FormatText
                textKey="proof.description"
                colours={[
                  "text-proof-green",
                  "text-proof-orange",
                  "text-proof-blue",
                  "text-proof-yellow",
                  "text-proof-purple",
                ]}
                classNames="dark:text-zinc-50 text-zinc-800 "
                type="caps"
              />
            </h2>
            <p className="mt-3 text-xl font-light text-white">{t("proof.intro.0")}</p>
            <p className="mt-3 text-xl font-light text-white">{t("proof.intro.1")}</p>
            <p className="mt-3 text-xl font-light text-white">{t("proof.intro.2")}</p>
            <Link to="/resources" className="button button-white mt-8">
              {t("proof.resourcesButton")}
            </Link>
          </div>
        </div>
      </section>
      <section>
        <div className="dark relative bg-gray-900 px-6 py-4">
          <Carousel items={proofCarousel} />
        </div>
      </section>
    </PageLayout>
  );
}
